import { render, staticRenderFns } from "./ProviderIcon.vue?vue&type=template&id=dd459706"
import script from "./ProviderIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderIcon.vue?vue&type=style&index=0&id=dd459706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports